import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { required } from "../../shared/src/codecs/types/required";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { literal } from "../../shared/src/codecs/types/literal";

export const ProbateGrantMatch = required({
    id: uuid(),
    match_confidence: union([literal("strong"), literal("weak")]),
    status: union([literal("pending"), literal("confirmed"), literal("dismissed")]),
    matched_name: union([string(), nullCodec()]),
    probate_number: string(),
    matched_on: union([string(), nullCodec()]),
});

export type TProbateGrantMatchCodec = typeof ProbateGrantMatch;
export type TProbateGrantMatch = TTypeOfCodec<TProbateGrantMatchCodec>;
